import React, { FunctionComponent, useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';
import { MyTextFiled } from '../UI/MyTextField';

interface Props {
  open: boolean;
  message: string;
  onClose: (e: any) => void;
  showCode?: boolean;
  buttonText?: string;
}

export const DialogConfirmation: FunctionComponent<Props> = ({
  open,
  message,
  onClose,
  showCode,
  buttonText,
}) => {
  const [code, setCode] = useState('');
  const [codeNeed, setCodeNeed] = useState(
    Math.floor(Math.random() * (99999 - 10000) + 10000)
  );
  const handleClose = (confirmation: boolean) => {
    if (showCode && confirmation && code !== codeNeed.toString()) {
      return;
    }
    onClose(confirmation);
  };

  useEffect(() => {
    if (open) {
      setCode('');
      setCodeNeed(Math.floor(Math.random() * (99999 - 10000) + 10000));
    }
  }, [open]);

  return (
    <div>
      <Dialog
        open={open}
        fullWidth
        maxWidth="xs"
        style={{ userSelect: 'none' }}
        PaperProps={{ sx: { backgroundColor: '#e7ebee', width: '100%' } }}
      >
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          Требуется подтверждение действия
        </DialogTitle>
        <DialogContent>
          <Stack spacing={1}>
            <DialogContentText>{message}</DialogContentText>
            {showCode && (
              <Typography
                style={{
                  fontFamily: 'sans-serif',
                  fontStyle: 'normal',
                  fontWeight: 500,
                  fontSize: '14px',
                  color: '#f44336',
                }}
                component="text"
              >
                {`Для подтверждения действия введите код ${codeNeed}`}
              </Typography>
            )}
            {showCode && (
              <MyTextFiled
                value={code}
                onChange={(e) => setCode(e.target.value)}
                size="small"
                label="Код подтверждения"
              />
            )}
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={() => handleClose(false)}>
            Отмена
          </Button>
          <Button
            disabled={showCode && code !== codeNeed.toString()}
            style={{
              color: showCode && code !== codeNeed.toString() ? 'grey' : 'red',
            }}
            onClick={() => handleClose(true)}
          >
            {buttonText}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

DialogConfirmation.defaultProps = {
  showCode: false,
  buttonText: 'Удалить',
};
